import { render } from "./ModalOrderProductTransfer.vue?vue&type=template&id=0629a259"
import script from "./ModalOrderProductTransfer.vue?vue&type=script&lang=js"
export * from "./ModalOrderProductTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__